import React, { useEffect, useState } from "react";
import { Box, Grid } from "@mui/material";
import { AppLayout } from "layout";
import { MyLearningData } from "modules/MyLearning/components";
import LearningLogData from "modules/MyLearning/components/LearningLogData/LearningLogData";
import { PurchasesService } from "services/PurchasesService";
import { Purchase } from "types";
import { useAuth } from "context/authContext";
import { LearningLogService } from "services/LearningLogService";

type Props = {};

type LearningLogItem = {
  id: string;
  contentTitle: string;
  createdAt: {
    seconds: number;
    nanoseconds?: number;
  };
};


const LearningLogContainer = (props: Props) => {
  const { currentUser } = useAuth();
  const [learningLogData, setLearningLogData] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPurchases = async () => {
      setLoading(true);
      try {
        if (!currentUser?.uid) {
          console.error("User ID is not available.");
          return;
        }

        const data = await LearningLogService.getAllLearningLogs(currentUser.uid);

        setLearningLogData(data);
      } catch (err) {
        console.error("Error fetching purchases:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchPurchases();
  }, [currentUser]);

  return (
    <AppLayout>
      <Box bgcolor={"#fff"}>
        <LearningLogData learningLogData={learningLogData} loading={loading} />
      </Box>
    </AppLayout>
  );
};

export default LearningLogContainer;
